export default __webpack_public_path__ + "static/media/2019-plan-1.f466dba3.jpeg";